/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreOverview } from './StoreOverview';
import {
    StoreOverviewFromJSON,
    StoreOverviewFromJSONTyped,
    StoreOverviewToJSON,
    StoreOverviewToJSONTyped,
} from './StoreOverview';

/**
 * 
 * @export
 * @interface StoreProfileNewRequestOverview
 */
export interface StoreProfileNewRequestOverview {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileNewRequestOverview
     */
    id: string;
    /**
     * 
     * @type {StoreProfileNewRequestOverviewApprovalStatusEnum}
     * @memberof StoreProfileNewRequestOverview
     */
    approvalStatus: StoreProfileNewRequestOverviewApprovalStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileNewRequestOverview
     */
    storeProfileVisibleAfterApproval?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileNewRequestOverview
     */
    rejectionReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileNewRequestOverview
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileNewRequestOverview
     */
    updatedAt?: Date;
    /**
     * 
     * @type {StoreOverview}
     * @memberof StoreProfileNewRequestOverview
     */
    store: StoreOverview;
}


/**
 * @export
 */
export const StoreProfileNewRequestOverviewApprovalStatusEnum = {
    InReview: 'IN_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED'
} as const;
export type StoreProfileNewRequestOverviewApprovalStatusEnum = typeof StoreProfileNewRequestOverviewApprovalStatusEnum[keyof typeof StoreProfileNewRequestOverviewApprovalStatusEnum];


/**
 * Check if a given object implements the StoreProfileNewRequestOverview interface.
 */
export function instanceOfStoreProfileNewRequestOverview(value: object): value is StoreProfileNewRequestOverview {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('approvalStatus' in value) || value['approvalStatus'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function StoreProfileNewRequestOverviewFromJSON(json: any): StoreProfileNewRequestOverview {
    return StoreProfileNewRequestOverviewFromJSONTyped(json, false);
}

export function StoreProfileNewRequestOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileNewRequestOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'approvalStatus': json['approvalStatus'],
        'storeProfileVisibleAfterApproval': json['storeProfileVisibleAfterApproval'] == null ? undefined : json['storeProfileVisibleAfterApproval'],
        'rejectionReason': json['rejectionReason'] == null ? undefined : json['rejectionReason'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'store': StoreOverviewFromJSON(json['store']),
    };
}

export function StoreProfileNewRequestOverviewToJSON(json: any): StoreProfileNewRequestOverview {
    return StoreProfileNewRequestOverviewToJSONTyped(json, false);
}

export function StoreProfileNewRequestOverviewToJSONTyped(value?: StoreProfileNewRequestOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'approvalStatus': value['approvalStatus'],
        'storeProfileVisibleAfterApproval': value['storeProfileVisibleAfterApproval'],
        'rejectionReason': value['rejectionReason'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'store': StoreOverviewToJSON(value['store']),
    };
}

